export function handleCloseAutoFocus(e: Event): void {
    e.preventDefault();
    e.stopPropagation();
}
